import { render, staticRenderFns } from "./ProductCommentById.vue?vue&type=template&id=5689e7b3&scoped=true&"
import script from "./ProductCommentById.vue?vue&type=script&lang=js&"
export * from "./ProductCommentById.vue?vue&type=script&lang=js&"
import style0 from "./ProductCommentById.vue?vue&type=style&index=0&id=5689e7b3&lang=scss&scoped=true&"
import style1 from "./ProductCommentById.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5689e7b3",
  null
  
)

export default component.exports